var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.noviceContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }